<!-- Do not change this file. -->
<template>
  <div>
    <div class="d-flex justify-content-between p-2 fw-bold border-bottom">
      <span>Codes</span><span>Last Updated</span>
    </div>
    <div
      v-for="code in intregityMap"
      :key="code"
      class="d-flex justify-content-between p-2 alert border-0 text-dark rounded-0 m-0"
      :class="[`alert-${code.state}`]"
    >
      <span>{{ code.code }}</span
      ><span>{{ code.formattedDateTime }}</span>
    </div>
    <div class="alert alert-secondary m-0 text-start d-none">
      <pre>{{ value.codes }}</pre>
    </div>
  </div>
</template>

<script>
/* Do not change this file. */

import { formatDateTime } from "@/helpers/common.js";

import { mapGetters } from "vuex";

const MINUTE = 60;
const HOUR = MINUTE * 60;
const DAY = HOUR * 24;

export default {
  name: "CustomActiveEntry",
  props: {
    value: Object
  },
  computed: {
    ...mapGetters(["getAchievements"]),
    intregityMap() {
      let codes = this.value.codes;

      let previousTimestamp = 0;
      let threshold = 2 * DAY;

      codes = codes.map((code) => {
        let state = "";
        if (previousTimestamp === 0) {
          previousTimestamp = code.tsLastUpdated;
        } else if (code.tsLastUpdated < previousTimestamp + threshold) {
          state = "warning";
        }

        return {
          ...code,
          state,
          formattedDateTime: formatDateTime(code.tsLastUpdated)
        };
      });

      return codes;
    }
  },
  methods: {
    formatDateTime
  }
};
</script>
